module.exports = __webpack_public_path__ + "01aec4e78ac3d2cc288e5cb1c019f476.MP3";